var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgBetsIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 96,
    height: 97,
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M51 43.4a5 5 0 0 1 3.1-4.6l35-14.4A5 5 0 0 1 96 29v48c0 2.2-1.3 4-3.3 4.8l-35 13A5 5 0 0 1 51 90V43.4Zm37 .9c0 3.3-2 6-4.5 6s-4.5-2.7-4.5-6 2-6 4.5-6 4.5 2.7 4.5 6Zm-4.5 29c2.5 0 4.5-2.7 4.5-6s-2-6-4.5-6-4.5 2.7-4.5 6 2 6 4.5 6Zm-11.5 0c0 3.3-2 6-4.5 6s-4.5-2.7-4.5-6 2-6 4.5-6 4.5 2.7 4.5 6Zm-4.5-18c2.5 0 4.5-2.7 4.5-6s-2-6-4.5-6-4.5 2.7-4.5 6 2 6 4.5 6ZM49.2.2a5 5 0 0 0-3.2 0L12.1 12a5 5 0 0 0-.4 9.3l33.9 15.4a5 5 0 0 0 4 0l36.1-15.3a5 5 0 0 0-.4-9.3L49.2.2Zm-2 20.5c5 0 9-1.8 9-4s-4-4-9-4-9 1.8-9 4 4 4 9 4ZM43 39.2a5 5 0 0 1 3 4.6V91a5 5 0 0 1-6.8 4.7L3.5 82.3a5 5 0 0 1-3.2-4.6V28a5 5 0 0 1 7-4.5l35.6 15.6Zm-25.8 2.5c0 3.3-2 6-4.5 6-2.4 0-4.5-2.7-4.5-6s2-6 4.5-6 4.5 2.7 4.5 6Zm12.5 40c2.5 0 4.5-2.7 4.5-6s-2-6-4.5-6c-2.4 0-4.5 2.7-4.5 6s2 6 4.5 6Z",
    fill: "#fff"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgBetsIcon);
export default __webpack_public_path__ + "static/media/bets_icon.6f96c6cf3b4570823f514a5292adf70c.svg";
export { ForwardRef as ReactComponent };